import type { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import type { ElibooApp } from '@eliboo/api-models';

import { catchError, map, of } from 'rxjs';

import { useGetChannelOperatorConfig } from '../api/biz/use-channel-operator-config.api';

export const channelOperatorConfigResolver: ResolveFn<ElibooApp.ChannelOperatorConfigDTO> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  console.log('channelOperatorConfigResolver', route, state.url);
  const getChannelOperatorConfig = useGetChannelOperatorConfig().api;
  return getChannelOperatorConfig().pipe(
    map((res) => {
      const data = res.data;
      return data;
    }),
    catchError((err) => {
      console.log("bizLicenseResolver error", err);
      return of({})
    }),
  );
};
